const inputMaxLengths = {
    custAuthContact: 40,
    custPhoneNo: 20,
    serviceAt: 45,
    details: 120,
    customer: 45,
    purchaseOrder: 20,
    make: 25,
    model: 25,
    serial: 25,
    source: 8,
    qty: 4,
    materialDescription: 23,
    price: 9,
    workorderNumber: 25,
    date: 25,
    techName: 26,
    hours: 5,
    invoiceNumber: 20,
    quoteNumber: 20,
  };
  
  export {inputMaxLengths};